(() => {
  const setPlayingState = (video, isPlaying) => {
    const card = video.closest('.lobo-ugc__card');
    const playButton = card?.querySelector('.lobo-ugc__play');

    if (!playButton) return;

    playButton.hidden = isPlaying;
    playButton.setAttribute('aria-pressed', String(isPlaying));
  };

  document.addEventListener('click', (event) => {
    const playButton = event.target.closest('.lobo-ugc__play');

    if (playButton) {
      const video = playButton.closest('.lobo-ugc__card')?.querySelector('.lobo-ugc__video');
      if (!video) return;

      document.querySelectorAll('.lobo-ugc__video').forEach((otherVideo) => {
        if (otherVideo !== video && !otherVideo.paused) otherVideo.pause();
      });

      video.play().catch(() => setPlayingState(video, false));
      return;
    }

    const video = event.target.closest('.lobo-ugc__video');
    if (video && !video.paused) video.pause();
  });

  document.addEventListener('play', (event) => {
    if (event.target.matches('.lobo-ugc__video')) setPlayingState(event.target, true);
  }, true);

  document.addEventListener('pause', (event) => {
    if (event.target.matches('.lobo-ugc__video')) setPlayingState(event.target, false);
  }, true);

  document.addEventListener('ended', (event) => {
    if (event.target.matches('.lobo-ugc__video')) setPlayingState(event.target, false);
  }, true);
})();
